import React from 'react';
import { Table, Input, Form, Select } from 'antd';

const { Option } = Select;

const EditableContext = React.createContext();

class EditableCell extends React.Component {

  renderRoleSelect = () =>
    <Select style={{ width: 100 }}>
      <Option value="user">user</Option>
    </Select>

  renderStatusSelect = () =>
    <Select style={{ width: 100 }}>
      <Option value="active">active</Option>
      <Option value="pending">pending</Option>
    </Select>

  getInput = () => {
    switch (this.props.inputType) {
      case 'roleSelect':
        return this.renderRoleSelect();
      case 'statusSelect':
        return this.renderStatusSelect();
      case 'text':
      default:
        return <Input />;
    }
  };

  renderCell = ({ getFieldDecorator }) => {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      children,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [],
              initialValue: record[dataIndex],
            })(this.getInput())}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  render() {
    return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>;
  }
}

class EditableTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      editingKey: ''
    };
    this.columns = [
      {
        title: 'username',
        dataIndex: 'username',
        width: '15%',
        editable: false,
      },
      {
        title: 'displayName',
        dataIndex: 'displayName',
        width: '15%',
        editable: true,
      },
      {
        title: 'role',
        dataIndex: 'role',
        width: '10%',
        editable: true,
      },
      {
        title: 'created at',
        dataIndex: 'createdAt',
        width: '20%',
        editable: false,
      },
      {
        title: 'last login at',
        dataIndex: 'lastLoginAt',
        width: '20%',
        editable: false,
      },
      {
        title: 'status',
        dataIndex: 'status',
        width: '10%',
        editable: true,
      },
      {
        title: 'operation',
        dataIndex: 'operation',
        render: (text, record) => {
          const { editingKey } = this.state;
          const editable = this.isEditing(record);
          return editable ? (
            <span>
              <EditableContext.Consumer>
                {form => (
                  <a
                    href="#"
                    onClick={() => this.save(form, record.id)}
                    style={{ marginRight: 8 }}
                  >
                    Save
                  </a>
                )}
              </EditableContext.Consumer>
              <a
                href="#"
                onClick={() => this.cancel(record.id)}
              >
                Cancel
              </a>
            </span>
          ) : (
            <a
              href="#"
              disabled={editingKey !== ''}
              onClick={() => this.edit(record.id)}
            >
              Edit
            </a>
          );
        },
      },
    ];
  }

  isEditing = record => record.id === this.state.editingKey;

  cancel = () => {
    this.setState({ editingKey: '' });
  };

  save(form, key) {
    form.validateFields((error, row) => {
      if (error) {
        return;
      }
      const newData = [...this.state.data];
      const index = newData.findIndex(item => key === item.id);
      if (index > -1) {
        const item = newData[index];
        this.props.onSaveData({ ...row, id: item.id });
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        this.setState({ data: newData, editingKey: '' });
      } else {
        newData.push(row);
        this.setState({ data: newData, editingKey: '' });
      }
    });
  }

  edit(key) {
    this.setState({ editingKey: key });
  }

  getInputType(dataIndex) {
    switch (dataIndex) {
      case 'role':
        return 'roleSelect';
      case 'status':
        return 'statusSelect';
      default:
        return 'text';
    }
  }

  render() {
    const components = {
      body: {
        cell: EditableCell,
      },
    };

    const columns = this.columns.map(col => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType: this.getInputType(col.dataIndex),
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
        }),
      };
    });

    return (
      <EditableContext.Provider value={this.props.form}>
        <Table
          components={components}
          bordered
          dataSource={this.state.data}
          columns={columns}
          rowClassName="editable-row"
          pagination={{
            onChange: this.cancel,
          }}
        />
      </EditableContext.Provider>
    );
  }
}

export default Form.create()(EditableTable);